import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import { getReactRecoilSettings } from '../../settings.js';
const orderDetailsState = buildServiceState({
    allowEmptyRequest: false,
    key: 'orderDetails',
    service: Core.GetOrder,
    beforeRequest: ({ req }) => {
        // State with allowEmptyRequest false should not amend
        // the request when empty or it will implicitly make an empty request
        // an actual request resulting in an unwanted call
        //
        if (!req) {
            return;
        }
        if (!req.OrderID) {
            throw new Error('Missing required order identifier');
        }
        const settings = getReactRecoilSettings();
        const newRequest = {
            AdditionalOrderDataOptions: settings.currentOrderOptions,
            IncludeAllPayments: true,
            ShowOnlyShippableLines: false,
            ...req,
        };
        return newRequest;
    },
});
export default orderDetailsState;
//# sourceMappingURL=order-details-state.js.map